(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('action-refresh-panel', actionRefreshPanel);

    function actionRefreshPanel(lodash, $q, PanelManager) {
        return function(option) {
            $q.when([run(option)]);
        };

        function run(option) {
            if (lodash.has(option, 'panel_ids')) {
                // refresh that panel only
                let panel_ids = option.panel_ids;
                if (!(option.panel_ids instanceof Array)) {
                    panel_ids = [panel_ids];
                }

                for (const _panel_id of panel_ids) {
                    const _panel = PanelManager.get(_panel_id);
                    executeRefresh(option, _panel);
                }
            }
            if (!lodash.has(option, 'panel_ids')) {
                // refresh all panel
                const panels = PanelManager.getAll();
                for (const _panel of panels) {
                    executeRefresh(option, _panel);
                }
            }
        }

        function executeRefresh(options, panel) {
            if (!panel) return;
            const type = lodash.get(options, 'type', '');
            const showLoading = lodash.get(options, 'show_loading', false);

            switch (type) {
                case "model": {
                    return panel.refreshModel(showLoading);
                }
                case "structure": {
                    return panel.refreshStructure(showLoading);
                }
                case "none": {
                    return true;
                }
                case "all":
                default: {
                    return panel.refresh(showLoading);
                }
            }
        }
    }
})();